/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 *
 * Is the signed-in user an owner/admin of their primary workspace? Gates the
 * customer-facing System Settings area (their company setup) — distinct from
 * platform staff (usePlatformAdmin) and from ordinary members.
 */

import { useEffect, useState } from "react";
import { getMyPrimaryAccount } from "../utils/accountService.js";

export function useWorkspaceAdmin() {
  const [state, setState] = useState({ isWorkspaceAdmin: false, checked: false });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const acct = await getMyPrimaryAccount();
        const ok = acct?.role === "owner" || acct?.role === "admin";
        if (alive) setState({ isWorkspaceAdmin: !!ok, checked: true });
      } catch {
        if (alive) setState({ isWorkspaceAdmin: false, checked: true });
      }
    })();
    return () => { alive = false; };
  }, []);

  return state;
}
